import { Action } from '@ngrx/store';
import { DestinationReasonsAction } from '../constants';

export class GetDestinationReasons implements Action {
  readonly type = DestinationReasonsAction.GetDestinationReasons;
}

export class GetDestinationReasonsSuccess implements Action {
  readonly type = DestinationReasonsAction.GetDestinationReasonsSuccess;
  constructor(public data: any[]) {}
}

export class GetDestinationReasonsError implements Action {
  readonly type = DestinationReasonsAction.GetDestinationReasonsError;
}

export class GetDestinationReasonById implements Action {
  readonly type = DestinationReasonsAction.GetDestinationReasonById;
  constructor(public id: string) {}
}

export class GetDestinationReasonByIdSuccess implements Action {
  readonly type = DestinationReasonsAction.GetDestinationReasonByIdSuccess;
  constructor(public data: any) {}
}

export class GetDestinationReasonByIdError implements Action {
  readonly type = DestinationReasonsAction.GetDestinationReasonByIdError;
}

export class PostDestinationReason implements Action {
  readonly type = DestinationReasonsAction.PostDestinationReason;
  constructor(public data: any) {}
}

export class PostDestinationReasonSuccess implements Action {
  readonly type = DestinationReasonsAction.PostDestinationReasonSuccess;
  constructor(public data: any) {}
}

export class PostDestinationReasonError implements Action {
  readonly type = DestinationReasonsAction.PostDestinationReasonError;
}

export class PutDestinationReason implements Action {
  readonly type = DestinationReasonsAction.PutDestinationReason;
  constructor(public data: any) {}
}

export class PutDestinationReasonSuccess implements Action {
  readonly type = DestinationReasonsAction.PutDestinationReasonSuccess;
  constructor(public data: any) {}
}

export class PutDestinationReasonError implements Action {
  readonly type = DestinationReasonsAction.PutDestinationReasonError;
}

export class DeleteDestinationReason implements Action {
  readonly type = DestinationReasonsAction.DeleteDestinationReason;
  constructor(public id: string) {}
}

export class DeleteDestinationReasonSuccess implements Action {
  readonly type = DestinationReasonsAction.DeleteDestinationReasonSuccess;
  constructor(public id: string) {}
}

export class DeleteDestinationReasonError implements Action {
  readonly type = DestinationReasonsAction.DeleteDestinationReasonError;
}

export type DestinationReasonsActions = 
  | GetDestinationReasons
  | GetDestinationReasonsSuccess
  | GetDestinationReasonsError
  | GetDestinationReasonById
  | GetDestinationReasonByIdSuccess
  | GetDestinationReasonByIdError
  | PostDestinationReason
  | PostDestinationReasonSuccess
  | PostDestinationReasonError
  | PutDestinationReason
  | PutDestinationReasonSuccess
  | PutDestinationReasonError
  | DeleteDestinationReason
  | DeleteDestinationReasonSuccess
  | DeleteDestinationReasonError;